import { render } from "./Forum.vue?vue&type=template&id=59ddd5e2"
import script from "./Forum.vue?vue&type=script&lang=js"
export * from "./Forum.vue?vue&type=script&lang=js"
script.render = render

export default script